/*
 app dependencies
 -

 lib dependencies
 - jQuery
*/

const scUi = (function($)
{

	//module functions
	function init()
	{
		$('[data-bg]').databg();

		enhanceForms();

		formSubmits();

		_scoreBars();

		lmnSocialPopup.init();

		body.classList.add('ui-initiated');
	}

	function enhanceForms($parent = $('body'))
	{
		//dropdowns
		$parent.find('select.js-chosen').chosen();
		//date fields
		$parent.find('input.js-datepicker').datetimepicker({
		    timepicker:false,
		    format:'d-m-Y',
			maxDate: 0,
		    scrollInput: false
		});
		$parent.find('.js-trigger-calendar').on('click', function(e)
		{
			e.preventDefault();
			$(`[name="${$(this).data('date-field')}"]`).focus();
		});
		//rich textareas
		tinymce.init({
	        selector:'textarea.htmleditor',
	        toolbar: 'undo redo | bullist numlist | link blockquote',
	        plugins: "anchor, lists, link",
	        menubar: false
	    });

		//scoring
		$('ul.set-score-list label').each(function()
		{
			this.innerHTML = `<span>${this.textContent}</span>`;
		});
		$('ul.set-score-list input')
			.addClass('validate-me')
			.attr('data-validation', 'required')
			.attr('data-append-error-to', '.field.set-score-list');

		//social fields
		$('div.field--facebook .middleColumn').append(`<div class="field__icon-wrap">${iconSvg('facebook')}</div>`);
		$('div.field--twitter .middleColumn').append(`<div class="field__icon-wrap">${iconSvg('twitter')}</div>`);
		$('div.field--website .middleColumn').append(`<div class="field__icon-wrap">${iconSvg('website')}</div>`);
	}
	function updateChosen($parent = $('body'))
	{
		$parent.find('select.js-chosen').trigger("chosen:updated");
	}


	function formSubmits($parent = $('body'))
	{
		$parent.find('.js-validate-on-submit:not(.js-validate-on-submit--initiated)').on('submit', function(e)
		{
			if (!$(this).validateForm())
			{
				e.preventDefault();
			}
		}).addClass('js-validate-on-submit--initiated');
	}


	function _scoreBars()
	{
		Array.from(document.querySelectorAll('.js-fill-bar')).forEach(function(bar)
		{
			if (bar.dataset.percentage)
			{
				bar.style.width = `${bar.dataset.percentage}%`;
				bar.style.maxWidth = '100%';
			}
		});
	}


	function iconSvg(id)
	{
		return `<svg role="presentation" class="icon icon--${id}"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/themes/sc/assets/img/sprite.svg#${id}"></use></svg>`;
	}


	function loginPopup(body = '<p>Voor het gebruik van deze functionaliteit moet u inloggen.</p>')
	{
		lmnDialog.dialog({
			title: 'Inloggen',
			body: body,
			buttons: [
				{ type: 'link', link: '/Security/login', label: 'Inloggen', classes: 'btn btn--xxs-to-md' },
				{ type: 'link', link: '/registreren', label: 'Registreren', classes: 'btn btn--xxs-to-md' }
			],
			popup_class: "popup--account"
		});
	}

	//reveal public vars and functions
	return {
		//vars

		//functions
		init,
		enhanceForms,
		formSubmits,
		updateChosen,
		iconSvg,
		loginPopup
	};

})(jQuery);
